import { INIT, SUCCESS, LOADING, ERROR } from "../../../utils/constants";
import {
  GET_AZURE_CDN,
  GET_AZURE_CDN_SUCCESS,
  GET_AZURE_CDN_ERROR,
} from "./constant";

const initialState = {
  phase: INIT,
  azureCDNList: null,
  error: null,
};

/**
 * User Reducer
 * @param {Object} state
 * @param {Object} action
 */

export function AzureCDNStore(state = initialState, action) {
  switch (action.type) {
    case GET_AZURE_CDN:
      return {
        ...state,
        phase: LOADING,
      };
    case GET_AZURE_CDN_SUCCESS:
      return {
        ...state,
        phase: SUCCESS,
        azureCDNList: action.data,
        error: null,
      };
    case GET_AZURE_CDN_ERROR:
      return { ...state, phase: ERROR, error: action.error };

    default:
      return state;
  }
}
